import { v4 as uuidv4 } from "uuid";
import { Question, QuestionType } from "@/types/question";

import * as questionDefaults from "../defaultQuestionsConfiguration";

export default function createQuestion(type: QuestionType): Question {
  return {
    question: "",
    type,
    cfg: (questionDefaults as Record<string, unknown>)[type] || {},
    hidden: false,
    id: uuidv4(),
  };
}
